/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Editor_LogoutInputs */

const fr_settings_editor_logout = /** @type {(inputs: Settings_Editor_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const en_settings_editor_logout = /** @type {(inputs: Settings_Editor_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Settings_Editor_LogoutInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_editor_logout = /** @type {((inputs?: Settings_Editor_LogoutInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Editor_LogoutInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_editor_logout(inputs)
	return en_settings_editor_logout(inputs)
});